import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { haCountryConfig } from '../lib/utils';

export const useIsHairAnalyzerVisible = () => {
  const productContext = useProductDetailContext(false);
  const { shopId } = useApolloClientHeaders();

  return Boolean(
    productContext?.product?.features?.hairAnalyzer && haCountryConfig[shopId]
  );
};
